import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { saveWorkingProjectByFields } from '@/store/slices/project';
import { Registration } from '@/types/registration.types';
import Container from '@ui/container/container';
import SwitchV2 from '@ui/switch-v2/switch-v2';
import Text from '@ui/text/text/text';
import useComputedRegistrationSettings from '../../hooks/use-computed-registration-settings';
import { selectIsSavingWorkingProject } from '@/store/slices/project/selectors';

export default function RequireConfirmationToggle() {
  const dispatch = useAppDispatch();
  const { courseOn, registrationSettings } = useComputedRegistrationSettings();
  const savingWorkingProject = useAppSelector(selectIsSavingWorkingProject);

  const confirmationRequired = registrationSettings?.registrationConfirmation;

  const toggleRequireEmailConfirmation = (value: boolean, on: boolean) => {
    if (!registrationSettings) return;
    const updatedSettings: Registration = {
      ...registrationSettings,
      registrationConfirmation: on,
      sendEmailConfirmation: true,
    };

    // Toggle off if confirmation is not required
    if (!on) {
      updatedSettings.emailLinkLimit = null;
    }

    dispatch(saveWorkingProjectByFields({ registration_settings: updatedSettings }));
  };

  return (
    <Container design="GlobalCont1" borderRadius="12px" padding="16px" className="flex ai-center jc-space-between">
      <Text tag="h6" className="H6">
        Require confirmation
      </Text>
      <div>
        <SwitchV2
          loading={!registrationSettings || savingWorkingProject}
          value={!!confirmationRequired}
          on={!!confirmationRequired}
          onClick={toggleRequireEmailConfirmation}
          disabled={courseOn}
        />
      </div>
    </Container>
  );
}
